"use client";

import Link from "next/link";
import type { ReactNode } from "react";

import { trackEvent } from "@/lib/analytics";

export type FixCtaTarget = "free_health_check" | "signup" | "pricing" | "demo";
export type FixCtaPosition = "top" | "middle" | "bottom";

type FixCtaLinkProps = {
  href: string;
  slug: string;
  target: FixCtaTarget;
  position: FixCtaPosition;
  className?: string;
  children: ReactNode;
};

/**
 * A tracked link for the `/fix/<slug>` template. The page is a server
 * component (it must stay indexable), so the click handler lives in this
 * small island. One event, `fix_cta_clicked`, with the article, the
 * destination and where on the page the click happened.
 */
export function FixCtaLink({
  href,
  slug,
  target,
  position,
  className,
  children,
}: FixCtaLinkProps) {
  return (
    <Link
      href={href}
      prefetch={false}
      className={className}
      onClick={() => {
        trackEvent({
          event: "fix_cta_clicked",
          metadata: { slug, target, position },
          sendInstantly: true,
        });
      }}
    >
      {children}
    </Link>
  );
}
